import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 8px;
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    max-width: 320px;
    text-align: center;
    margin: 0;
    font-family: ${theme.v2.font.family.primary};
    color: ${theme.v2.colors.brand.primaryExtraDark};
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-family: ${theme.v2.font.family.primary};
    max-width: 432px;
    margin: 0;
    text-align: center;
    color: ${theme.v2.colors.neutral.lowPure};
  `}
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
`;
